// extracted by mini-css-extract-plugin
export var container = "pages-account-card-__ReloadBalanceTakeover-module___container";
export var enablementFee = "pages-account-card-__ReloadBalanceTakeover-module___enablementFee";
export var reloadBalanceWrapper = "pages-account-card-__ReloadBalanceTakeover-module___reloadBalanceWrapper";
export var section = "pages-account-card-__ReloadBalanceTakeover-module___section";
export var sideBar = "pages-account-card-__ReloadBalanceTakeover-module___sideBar";